// **********************************************************
// 1.0 - Open Pin Modal
// **********************************************************

attachEvent('.image-with-pins__number', 'click', (ev) => {
  const parentEle = ev.target.closest('.image-with-pins__pin');
  const modalEle = parentEle.querySelector('.pin-modal');
  modalEle.classList.add('is-open-modal');
});
